<script>
import { totalSeconds } from '../variables.js';

export default {
    name: 'AudioPlayerWaveDiagram',
    props: {
        progress: 0,
        trackSlug: String,
        hotspots: Array | Boolean
    },
    data: () => {
      return {
        isMounted: false,
        markerPos: null,
      }
    },
    mounted() {
      this.calcMarkerPos();
      this.isMounted = true;
    },
    computed: {
      getMaskWidth() {
        return this.progress * 100 + '%';
      },
      linePath() {
        switch (this.trackSlug) {
          case 'neerach':
            return 'M0,66.015269 C125.074846,68.5728838 205.612866,66.1483817 241.614062,58.7417626 C289.314214,48.9282872 308.186953,29.9990732 354.400726,29.9990732 C409.351888,29.9990732 432.760475,48.4623982 473.343964,54.2374839 C513.927454,60.0125697 573.201563,60.0125697 627.363681,58.7417626 C681.305291,57.4761293 740.223942,49.0546259 770.300809,36.0017725 C801.052615,22.6560068 829.554673,6 867.384375,6 C942.213495,6 934.548535,14.5624441 980.53237,23.5664931 C1026.5162,32.570542 1028.53611,48.0071711 1096.1544,54.2374839 C1141.23326,58.3910258 1207.18179,62.3169542 1294,66.015269';
        
          case 'sauge2':
            return 'M1.13686838e-13,58.0746106 C101.447391,58.7573226 221.055992,61.4360012 260.198763,52.1332094 C320.605469,37.7767653 379.241438,-5.68434189e-14 421.634549,-5.68434189e-14 C464.027659,-5.68434189e-14 509.323043,37.8100193 585.859074,34.0965057 C619.874913,34.0965057 620.737961,39.0474064 674.90008,37.7767653 C728.84169,36.5112972 776.328125,27.4574881 826.925781,27.4574881 C877.523437,27.4574881 918.916888,26.4013758 977.53757,34.0965057 C1036.15825,41.7916356 1063.30123,47.2586404 1099.4332,47.2586404 C1135.56518,47.2586404 1135.08407,49.791226 1206.39304,52.1332094 C1226.88033,52.8060687 1294.19799,52.1332094 1294.00756,52.1332094';

          case 'sauge3':
            return 'M0,68.6418137 C101.447391,69.3245257 206.640272,71.4170684 263.237315,65.708572 C310.172779,60.9745628 301.451764,5.41374112 354.678026,0.436982556 C407.904289,-4.539776 439.832537,34.7124938 516.368568,30.9989802 C550.384407,30.9989802 600.855948,30.0411982 655.018067,28.7705571 C708.959677,27.505089 746.763697,38.9679968 784.785898,42.6482564 C822.808098,46.3285161 842.311319,51.3636687 880.141021,51.3636687 C920.446248,51.3636687 935.655178,52.0242281 968.116955,48.3439684 C1000.57873,44.6637088 1039.62372,29.6926393 1077.2672,28.7705571 C1126.27846,27.5700196 1135.08407,60.3584291 1206.39304,62.7004125 C1226.88033,63.3732718 1294.19799,62.7004125 1294.00634,62.7004125';
        
          default:
            return 'M5.68434189e-13,88.5585288 C101.447391,89.2412408 173.668745,85.3480333 216.664063,76.8789062 C278.989564,64.6021603 280.390625,31.1992188 338.445313,31.1992188 C396.5,31.1992188 428.311625,62.4483916 504.847656,58.734878 C538.863495,58.734878 573.201562,60.0055191 627.363681,58.734878 C681.305291,57.4694099 723.007812,43.046875 761,43.046875 C798.992187,43.046875 828.263523,60.8623579 866.093225,60.8623579 C906.398452,60.8623579 927.054687,43.046875 969.265625,43.046875 C1011.47656,43.046875 1052.42683,77.8009885 1090.07031,76.8789063 C1139.08157,75.6783688 1134.29788,57.5264949 1195.817,54.2311873 C1215.71841,53.1651566 1248.38008,60.7143963 1293.80201,76.8789063';
        }
      },
      fillPath() {
        switch (this.trackSlug) {
          case 'neerach':
            return 'M6.30959573e-13,66.0074349 C125.074846,68.5647159 205.612866,66.1405302 241.614063,58.734878 C289.314214,48.9226836 308.186953,29.9959405 354.400726,29.9959405 C409.351888,29.9959405 432.760475,48.4568554 473.343964,54.2311873 C513.927454,60.0055191 573.201563,60.0055191 627.363681,58.734878 C681.305291,57.4694099 740.223942,49.0490057 770.300809,35.9978562 C801.052615,22.6538326 829.554673,6 867.384375,6 C942.213495,6 934.548535,14.5613264 980.53237,23.5642 C1026.5162,32.5670736 1028.53611,48.0016877 1096.1544,54.2311873 C1141.23326,58.384187 1207.18179,62.3096028 1294,66.0074349 L1294,263 L0,263 L6.30959573e-13,66.0074349 Z';
        
          case 'sauge2':
            return 'M0,58.0746106 C101.447391,58.7573226 221.055992,61.4360012 260.198763,52.1332094 C320.605469,37.7767653 379.241438,1.42108547e-14 421.634549,1.42108547e-14 C464.027659,1.42108547e-14 509.323043,37.8100193 585.859074,34.0965057 C619.874913,34.0965057 620.737961,39.0474064 674.90008,37.7767653 C728.84169,36.5112972 776.328125,27.4574881 826.925781,27.4574881 C877.523437,27.4574881 918.916888,26.4013758 977.53757,34.0965057 C1036.15825,41.7916356 1063.30123,47.2586404 1099.4332,47.2586404 C1135.56518,47.2586404 1135.08407,49.791226 1206.39304,52.1332094 C1226.88033,52.8060687 1294.19799,52.1332094 1294.00634,52.1332094 L1294.00634,232.516082 L0,232.516082 L0,58.0746106 Z';

          case 'sauge3':
            return 'M1.13686838e-13,68.6418137 C101.447391,69.3245257 206.640272,71.4170684 263.237315,65.708572 C310.172779,60.9745628 301.451764,5.41374112 354.678026,0.436982556 C407.904289,-4.539776 439.832537,34.7124938 516.368568,30.9989802 C550.384407,30.9989802 600.855948,30.0411982 655.018067,28.7705571 C708.959677,27.505089 746.763697,38.9679968 784.785898,42.6482564 C822.808098,46.3285161 842.311319,51.3636687 880.141021,51.3636687 C920.446248,51.3636687 935.655178,52.0242281 968.116955,48.3439684 C1000.57873,44.6637088 1039.62372,29.6926393 1077.2672,28.7705571 C1126.27846,27.5700196 1135.08407,60.3584291 1206.39304,62.7004125 C1226.88033,63.3732718 1294.19799,62.7004125 1294.00552,62.7004125 L1294.00552,243.083285 L1.13686838e-13,243.083285';
        
          default:
            return 'M6.21724894e-15,88.5585288 C101.447391,89.2412408 173.668745,85.3480333 216.664063,76.8789062 C278.989564,64.6021603 280.390625,31.1992187 338.445313,31.1992187 C396.5,31.1992187 428.311625,62.4483916 504.847656,58.734878 C538.863495,58.734878 573.201562,60.0055191 627.363681,58.734878 C681.305291,57.4694099 723.007812,43.046875 761,43.046875 C798.992187,43.046875 828.263523,60.8623579 866.093225,60.8623579 C906.398452,60.8623579 927.054687,43.046875 969.265625,43.046875 C1011.47656,43.046875 1052.42683,77.8009885 1090.07031,76.8789063 C1139.08157,75.6783688 1134.29788,57.5264949 1195.817,54.2311873 C1215.71841,53.1651566 1248.38008,60.7143963 1293.80201,76.8789063 L1294,263 L-5.68434189e-13,263 L6.21724894e-15,88.5585288 Z';
        }
      },
      currentLabels() {
        return this.$store.getters.currentLabels;
      }
    },
    methods: {
      percentagePosition(pos) {
        return pos/totalSeconds;
      },
      percentageWidth(dur) {
        return dur/totalSeconds;
      },
      calcMarkerPos() {
        let pathEl = this.$refs.path;
        if(!pathEl) return;
        let pathLength = pathEl.getTotalLength();
        let x = this.progress * 1294;

        var start = 0
        var end = pathLength
        var target = (start + end) / 2

        x = Math.max(x, pathEl.getPointAtLength(0).x)
        x = Math.min(x, pathEl.getPointAtLength(pathLength).x)

        while (target >= start && target <= pathLength) {
          var pos = pathEl.getPointAtLength(target)

          if (Math.abs(pos.x - x) < 0.001) {
            // return pos.y
            break;
          } else if (pos.x > x) {
            end = target
          } else {
            start = target
          }
          target = (start + end) / 2
        }
        
        let posX = (pos.x/1294)*100 + '%';
        let posY = pos.y + 'px';
        this.markerPos = {
          x: posX,
          y: posY,
        }

        // window.requestAnimationFrame(this.calcMarkerPos);
        window.setTimeout(() => this.calcMarkerPos(), 50);
      },
    },
};
</script>

<template>
  <div class="wave-diagram">
    <svg preserveAspectRatio="none" width="1294px" height="170px" viewBox="0 0 1294 170" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <mask id="mask">
        <path :d="fillPath" fill="#fff"></path>
      </mask>
      <g id="Artboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path ref="fill" :d="fillPath" id="fill" fill="#FFFFFF"></path>
        <path ref="path" :d="linePath" id="path" stroke="#FFFFFF" stroke-width="2"></path>
      </g>
    </svg>
    <span v-if="isMounted" class="wave-diagram__marker" v-bind:style="{ left: markerPos.x, top: markerPos.y }"></span>
    <div  v-if="isMounted" class="wave-diagram__handle" v-bind:style="{ left: markerPos.x, top: markerPos.y }"></div>
  </div>
</template>

<style lang="scss" scoped>
svg {
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: visible;
}

#fill {
  fill: var(--color-main);
  // opacity: .5;
}
.hotspot {
  // fill: var(--color-main);
  fill: #E2A05A;
  opacity: .4;
}

.marker {
  fill: #fff;
}
.wave-diagram__handle {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 99%;
  width: 20px;
  height: 20px;
  background: #fff;
  border: var(--color-main) solid 0.125rem;
  transform: translate(-50%, -50%);
}
.wave-diagram__marker {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  bottom: -1rem;
  width: 2px;
  background: var(--light);
}
</style>
